<template>
  <!-- TextInput -->
  <div class="" :class="{ 'has-error': !!errorMessage, success: meta.valid }"
    :style="{ display: type != 'hidden' ? '' : 'none' }">
    <label v-if="label" :for="name">
      <i class="pi" :class="icon" />
      {{ label }}
    </label>
    <component v-if="meta?.mode == 'edit'" :is="inputComponent" v-bind="attrs" :id="name" :key="3" v-model="model"
      v-tooltip.top="errorMessage" :name="name" :type="'number' != type ? type : ''" :placeholder="placeholder"
      :mask="mask" :class="[
        className,
        {
          'p-invalid': !!errorMessage,
          success: meta.valid,
        },
      ]" :disabled="disabled" :readonly="readOnly" :maxlength="maxLength" />
    <div class="font-medium" v-else>{{ model || "" }}</div>
    <small v-if="errorMessage" class="p-error block mt-1">
      {{ errorMessage }}
    </small>
  </div>
</template>
<script>
import { useField } from "vee-validate";
import moment from "moment";
import { Core } from "../../../helpers/core";
export default {
  inject: ["meta"],
  props: {
    modelValue: { type: [String, Number] },
    value: { type: [String, Number] },
    label: { type: String },
    name: { type: String },
    icon: { type: String },
    type: { type: String, default: "text" },
    key: {
      type: [String, Number],
      default: "",
    },
    successMessage: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    className: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },
    maxLength: { type: Number, default: 256 },
    mask: { type: Number, default: 99 - 999999 },
    toFixed: { type: Number, default: 0 },
  },
  mounted() {
    if (this.meta?.key !== "create" || this.meta?.type === "template") return;
    if (this.type !== "date") return;
    if (this.modelValue != null && this.modelValue !== "") return;
    const today = Core.datey(new Date(), "YYYY-MM-DD");
    this.inputValue = today;
    this.handleChange(today);
    this.$emit("update:modelValue", today);
  },
  data() {
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      resetField,
      meta: fieldMeta,
    } = useField(this.name, (value) => !!value, {
      initialValue: this.parseValue(this.modelValue, 1),
    });
    let inputComponent = "number" == this.type ? "InputNumber" : "InputText";
    let data = {
      inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      resetField,
      fieldMeta,
      inputComponent,
    };
    return data;
  },
  methods: {
    parseValue(data, k = 2) {
      if (["date", "time", "datetime", "datetime-local"].includes(this.type)) {
        let format = "";
        if ("date" == this.type) {
          format = this.meta?.mode == "edit" ? "YYYY-MM-DD" : "MM/DD/YYYY";
        } else if ("time" == this.type) {
          format = "HH:mm";
        }
        data = Core.datey(data, format);
      }
      return data;
    },
  },
  computed: {
    model: {
      get() {
        return this.parseValue(this.modelValue);
      },
      set(value) {
        this.inputValue = value;
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style scoped>
.TextInput {
  position: relative;
  width: 100% !important;
}

input:focus {
  border-color: none;
}

.TextInput.has-error input {
  background-color: var(--error-bg-color);
  color: var(--error-color);
}

.TextInput.has-error input:focus {
  border-color: red;
}

/* .TextInput.success input {
  background-color: var(--success-bg-color);
  color: var(--success-color);
} */

.TextInput.success input:focus {
  border-color: var(--success-color);
}

.field {
  margin-bottom: 0rem;
}
</style>
